/**
 * Build version metadata injected by vite.config.ts via `define`.
 *
 * - APP_BUILD_TIME: ISO timestamp from `process.env.VITE_BUILD_TIME` (CI sets it)
 *   or `new Date().toISOString()` at the moment Vite ran.
 * - APP_GIT_COMMIT: short SHA from `process.env.VITE_GIT_COMMIT` / `GITHUB_SHA`,
 *   falling back to `git rev-parse --short HEAD` in the build host.
 */

declare const __APP_BUILD_TIME__: string;
declare const __APP_GIT_COMMIT__: string;

const REPO_URL = 'https://github.com/shayaansiddiqui/RealStateWithShayaan';

export const APP_BUILD_TIME: string =
    typeof __APP_BUILD_TIME__ !== 'undefined' ? __APP_BUILD_TIME__ : '';

export const APP_GIT_COMMIT: string =
    typeof __APP_GIT_COMMIT__ !== 'undefined' ? __APP_GIT_COMMIT__ : 'unknown';

/** YYYY.MM.DD from an ISO timestamp, in the client's local time zone. */
export function formatBuildDate(iso: string = APP_BUILD_TIME): string {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}.${m}.${day}`;
}

/** Localised "Wed, May 11, 2026, 1:45:23 PM EDT"-style string for the tooltip. */
export function formatBuildDateTimeLocal(iso: string = APP_BUILD_TIME): string {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    try {
        return d.toLocaleString(undefined, {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            timeZoneName: 'short',
        });
    } catch {
        return d.toString();
    }
}

/** "v2026.05.11 · abc1234" */
export function formatVersion(): string {
    const date = formatBuildDate();
    const commit = APP_GIT_COMMIT;
    if (!date && !commit) return '';
    if (!date) return commit;
    if (!commit || commit === 'unknown') return `v${date}`;
    return `v${date} · ${commit}`;
}

/** Link to the GitHub commit page if we have a real SHA. */
export function commitUrl(): string | null {
    if (!APP_GIT_COMMIT || APP_GIT_COMMIT === 'unknown') return null;
    return `${REPO_URL}/commit/${APP_GIT_COMMIT}`;
}
